import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { federatedComponent } from '@unisporkal/federation';

const CustomerNotifications = federatedComponent(
  'customer_notifications',
  './CustomerNotifications'
);

const element = document.getElementById('customer_notifications_application');
if (element) {
  const root = createRoot(element);
  root.render(
    <Suspense>
      <CustomerNotifications />
    </Suspense>
  );
}
